angular.module('backOffice').directive('switch', () => ({
    restrict: 'A',
    replace: true,
    scope: {
        ngDisabled: '=',
        ngModel: '=',
        click: '&',
        confirmationCallback: '&?',
        form: '=',
        id: '@',
        type: '@',
    },
    template: require('./switchTemplate.html'),
    controller: switchController,
}));

switchController.$inject = ['$scope'];

function switchController($scope) {
    $scope.hasSwitched = false;
    $scope.toggle = toggle;

    function toggle() {
        if (!$scope.ngDisabled) {
            if ($scope.confirmationCallback) {
                $scope.confirmationCallback().then(() => {
                    completeToggle();
                });
            } else if ($scope.click) {
                $scope.click();
                completeToggle();
            } else {
                completeToggle();
            }
        }
    }

    //
    // Private

    function completeToggle() {
        $scope.touched = true;
        $scope.hasSwitched = true;
        if ($scope.form !== undefined) {
            $scope.form.$dirty = true;
        }
        $scope.ngModel = !$scope.ngModel;
    }
}
